// extracted by mini-css-extract-plugin
export default {"menuHtmlItem":"menuHtmlItem_M9Kj"};